import { OnInit } from '@angular/core';
var UserIconListComponent = /** @class */ (function () {
    function UserIconListComponent() {
        this.useInitialsFallback = false;
    }
    UserIconListComponent.prototype.ngOnInit = function () {
    };
    UserIconListComponent.prototype.ngOnChanges = function () {
    };
    UserIconListComponent.prototype.getInitials = function (name) {
        if (!name) {
            return '';
        }
        return name
            .split(' ')
            .map(function (word) { return word.charAt(0); })
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };
    return UserIconListComponent;
}());
export { UserIconListComponent };
